module.exports = __webpack_public_path__ + "static/media/monitoramento.6975fe0c.ogg";